import React from 'react';
import { EG_SHIFT_COLORS, EG_SHIFT_LABELS, getShiftPresentation } from '../../lib/egShiftPresentation';

export function EGShiftLegend() {
  return <>
    {Object.entries(EG_SHIFT_LABELS).map(([type, label]) => <span key={type}><i style={{ background: EG_SHIFT_COLORS[type] }} aria-hidden="true" />{label}</span>)}
    <span className="eg-request-key">Requested</span>
    <span className="eg-mod-key"><i style={{ background: "#111111" }} aria-hidden="true" />MOD</span>
  </>;
}

export default function EGShiftSignal({ shift }) {
  const signal = getShiftPresentation(shift);
  return <div className="eg-shift-card" data-shift-type={signal.type} data-mod={shift?.mod === true ? "true" : undefined}>
    <span className="eg-shift-card__rail" style={{ background: signal.color }} aria-hidden="true" />
    <span className="eg-shift-card__content">
      <span className="eg-shift-card__label">{signal.label}</span>
      {signal.hasTimes && <strong className="eg-shift-card__time">{signal.timeLabel}</strong>}
      {shift && !signal.hasTimes && !['requested', 'unavailable', 'cross_center'].includes(shift.shift_type) && <span className="eg-shift-card__request">Time not set</span>}
      {signal.requested && shift?.shift_type !== 'requested' && <span className="eg-shift-card__request">Requested</span>}
      {shift?.notes && <span className="eg-shift-card__notes">{shift.notes}</span>}
    </span>
  </div>;
}
